import { combineReducers } from "redux";
import metadata from "./subreducers/metadata/metadata";
import { ModulesStoreSlice } from "./types";

export default combineReducers<ModulesStoreSlice>({
  metadata,
  // data: modelReducer
});
